import React, { useEffect, useMemo, useState } from 'react';
import './Reservations.css';
import { createOperator, getOperators, updateOperator } from '../../services/operatorService';
import OperatorModal from '../../components/modals/OperatorModal';
import Table from '../../components/common/Table';
import '../../components/common/IconButton.css';
import { IconPencil } from '../../components/common/Icons';
import { formatCuil } from '../../utils/formatters';

const OperatorsPage = () => {
  const [operators, setOperators] = useState([]);
  const [queryFilter, setQueryFilter] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  const loadOperators = async () => {
    const data = await getOperators();
    setOperators(data);
  };

  useEffect(() => {
    loadOperators();
  }, []);

  const filtered = useMemo(() => operators.filter((op) =>
    `${op.name} ${op.cuit} ${formatCuil(op.cuit)}`.toLowerCase().includes(queryFilter.toLowerCase())
  ), [operators, queryFilter]);

  const handleSave = async (data) => {
    if (selected) {
      await updateOperator(selected.id, data);
    } else {
      await createOperator(data);
    }
    setModalOpen(false);
    setSelected(null);
    await loadOperators();
  };

  const columns = [
    {
      id: 'name',
      header: 'Nombre',
      accessor: (op) => op.name || '',
      filterPlaceholder: 'Filtrar nombre'
    },
    {
      id: 'cuit',
      header: 'CUIT',
      accessor: (op) => formatCuil(op.cuit) || '',
      filterPlaceholder: 'Filtrar CUIT'
    },
    {
      id: 'actions',
      header: 'Acciones',
      headerClassName: 'th-center',
      sortable: false,
      filterable: false,
      cell: (op) => (
        <div className="inline-actions">
          <button
            type="button"
            className="icon-btn icon-btn--edit"
            onClick={() => { setSelected(op); setModalOpen(true); }}
            aria-label="Editar operador"
            title="Editar"
          >
            <IconPencil />
          </button>
        </div>
      )
    }
  ];

  return (
    <div className="page-wrapper">
      <div className="page-header">
        <h1>Operadores</h1>
        <div className="actions-row">
          <input
            className="search-input"
            placeholder="Buscar"
            value={queryFilter}
            onChange={(e) => setQueryFilter(e.target.value)}
          />
          <button className="btn" onClick={() => { setSelected(null); setModalOpen(true); }}>+ Nuevo Operador</button>
        </div>
      </div>

      <Table
        data={filtered}
        columns={columns}
        rowKey="id"
        className="table"
        emptyMessage="No hay operadores para mostrar."
      />

      <OperatorModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onSave={handleSave}
        initialData={selected}
      />
    </div>
  );
};

export default OperatorsPage;
